import { MappedClass, MappedProperty } from '@h5s/util-object';
import { CashRegisterPaymentType } from './cash-register-payment-type.enum';

@MappedClass()
export class CashRegisterConfigurablePayment {
  @MappedProperty()
  description: string;

  @MappedProperty()
  type: CashRegisterPaymentType;
}
